import { Tabs } from '@studio/design-system/tabs';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import { Styles } from './constants.js';
import type { RootProps } from './types.js';

/** `<Root>` component. */
export const Root = ({ children, className, tab, ...props }: RootProps): ReactElement => (
  <div className={twMerge('h-full', Styles.root, className)} {...props}>
    <Tabs className='h-full' onChange={tab.setValue} value={tab.value}>
      {children}
    </Tabs>
  </div>
);
